/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { styled } from 'styled-components';
import { IconButton as BaseIconButton } from '@mui/material';
import React from 'react';
import { LoadingSpinner, joinDataTestId } from '@motili/ui';
import { IconButtonProps } from './types';
import _ from 'lodash';

interface StyledIconProps {
    disabled?: boolean;
    iconColor?: string;
}

export const styleIcon = <T extends React.ElementType>(IconComponent: T) => {
    return styled(IconComponent)<StyledIconProps>`
        ${({ iconColor, disabled, theme }) =>
            iconColor &&
            `
        color: ${disabled ? '#818181' : iconColor};
      `}
        &:hover {
            opacity: ${({ disabled }) => (disabled ? 1 : 0.8)};
        }
        font-size: inherit !important;
    `;
};

const StyledIconButton = styled(BaseIconButton)<{
    disabled?: boolean;
    fontSize?: string;
}>`
    ${({ disabled }) =>
        disabled
            ? 'cursor: not-allowed !important;'
            : 'cursor: pointer !important;'}
    ${({ fontSize }) => `
      font-size: ${fontSize || '24px'} !important;
    `}
`;

export const IconButton = (props: IconButtonProps) => {
    const attributes = _.omit(props, ['controlId']);
    const dataTestId = joinDataTestId([props.controlId, 'button']);

    if (props.busy) {
        return (
            <StyledIconButton
                data-test-id={dataTestId}
                disabled={props.disabled || props.busy}
                {...attributes}
            >
                <LoadingSpinner size='xsmall' busy />
            </StyledIconButton>
        );
    }
    return <StyledIconButton data-test-id={dataTestId} {...attributes} />;
};
